import { LEEWAY_DURATION } from "../constants";
import { diffIn, makeTimestamp } from "./date-helper";
export const getLeewayDuration = () => LEEWAY_DURATION;
export const getBufferDuration = (duration) => {
    if (duration >= 900)
        return 20;
    if (duration >= 300)
        return 15;
    return 10;
};
export const getMatchStartedAt = (match, moves) => {
    const matchStartedAt = match.startedAt || match.createdAt;
    // FIXME: This is to prevent bugs where match.startedAt is updated after a move has been performed
    const firstMove = moves.length >= 1 ? moves.at(0) : null;
    if (firstMove && firstMove.createdAt < matchStartedAt) {
        return firstMove.createdAt;
    }
    return matchStartedAt;
};
export const getCommencedMove = (match, moves) => {
    return match.tournamentId
        ? moves?.length >= 1
            ? moves?.at(0)
            : null
        : moves?.length >= 2
            ? moves?.at(1)
            : null;
};
export const getCommencedAt = (match, moves) => {
    if (match.commencedAt)
        return match.commencedAt;
    const commencedMove = getCommencedMove(match, moves);
    if (match.tournamentId) {
        const startedDate = getMatchStartedAt(match, moves);
        if (!startedDate)
            return undefined;
        const leeway = getLeewayDuration();
        const theoreticalCommencedAt = makeTimestamp(startedDate.seconds + leeway, startedDate.nanoseconds);
        if (commencedMove?.createdAt) {
            return theoreticalCommencedAt.seconds < commencedMove.createdAt.seconds
                ? theoreticalCommencedAt
                : commencedMove.createdAt;
        }
        if (diffIn(new Date(), startedDate, "second") >= leeway) {
            return theoreticalCommencedAt;
        }
    }
    else if (commencedMove?.createdAt) {
        return commencedMove.createdAt;
    }
    return undefined;
};
export const hasCommenced = (match, moves) => {
    return hasCommencedByMoveCount(match, moves) || !!getCommencedAt(match, moves);
};
export const hasCommencedByMoveCount = (match, moves) => {
    return !!getCommencedMove(match, moves);
};
